import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { NgForOf } from '@angular/common';
import {ChangeDomainPipe} from "../../pipes/change-domain.pipe";

interface FaqItem {
    question: string;
    answer: string[]; // IMMER Array
}

interface FaqCategory {
    title: string;
    items: FaqItem[];
}

@Component({
    selector: 'app-faq',
    standalone: true,
    imports: [AccordionModule, NgForOf, ChangeDomainPipe],
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
    faqs: FaqCategory[] = [
        {
            title: 'Allgemein',
            items: [
                {
                    question: 'Was ist {{domain}}?',
                    answer: [
                        '{{domain}} ist eine moderne, digitale Workflow-Lösung der deutschen IMZAFLOW UG, die speziell für deutsche Organisationen und deren internationale Geschäftsprozesse entwickelt wurde. Die Plattform kombiniert drei Kernmodule: {{domain}}.sign mit elektronischen Signaturen, imza.dms als Dokumentenmanagement-System und imza.task, ein rollenbasiertes Aufgaben-Management in einem integrierten System.',
                        'Start in Europa und die internationale Expansion in die Türkei und Schweiz ist für 2026 geplant.'
                    ]
                },
                {
                    question: 'Um welche Art der elektronischen Signatur handelt es sich?',
                    answer: [
                        'Die Plattform unterstützt einfache (EES), fortgeschrittene (FES) und qualifizierte elektronische Signaturen (QES) nach eIDAS, ZertES und türkischem E-İmza-Gesetz.'
                    ]
                },
                {
                    question: 'Wie erstellt man eine elektronische Signatur mit {{domain}}?',
                    answer: [
                        'Dokument hochladen, Signaturart auswählen und mit wenigen Klicks signieren. Für QES ist eine einmalige Identifikation (VideoIdent, eID oder Smartcard) notwendig.'
                    ]
                },
                {
                    question: 'Gibt es eine mobile App?',
                    answer: [
                        '{{domain}} ist als Web-App responsive für mobile Geräte optimiert. Native Apps für iOS und Android sind in Planung.'
                    ]
                },
                {
                    question: 'Welche Funktionen bietet {{domain}}?',
                    answer: [
                        'Elektronische Signaturen (EES, FES, QES)',
                        'Dokumentenmanagement-System (DMS, nur on premise)',
                        'Rollenbasiertes Aufgabenmanagement (nur on premise)',
                        'Workflow-Automatisierung',
                        'Audit-Trails & Protokollierung',
                        'API-Schnittstellen für Integration'
                    ]
                },
                {
                    question: 'Vorteile von {{domain}}',
                    answer: [
                        'Rechtssicherheit, Prozessbeschleunigung, Kosteneinsparung, internationale Einsetzbarkeit, einfache Integration in bestehende Systeme.'
                    ]
                }
            ]
        },
        {
            title: 'Rechtliches, Sicherheit, Beweisbarkeit',
            items: [
                {
                    question: 'Sind elektronische Signaturen von imza.sign rechtssicher?',
                    answer: [
                        'Ja. {{domain}} erfüllt die Anforderungen der eIDAS-Verordnung (EU), ZertES (CH) und des türkischen E-İmza-Gesetzes. QES-Signaturen sind rechtlich der handschriftlichen Unterschrift gleichgestellt.'
                    ]
                },
                {
                    question: 'Ist die elektronische Signatur mit imza.sign beweisbar?',
                    answer: [
                        'Ja. Jede Signatur wird kryptographisch abgesichert und mit Audit-Trails dokumentiert. Jede Veränderung am Dokument nach der Signatur wird erkannt.'
                    ]
                },
                {
                    question: 'Ist {{domain}} DSGVO-konform?',
                    answer: [
                        'Ja. Alle Daten werden DSGVO-konform verarbeitet. Serverstandorte befinden sich ausschließlich in der EU.'
                    ]
                },
                {
                    question: 'Wie erkenne ich, dass ein Dokument nicht verändert wurde?',
                    answer: [
                        'Die Integrität der Dokumente wird durch Hashwerte und digitale Zertifikate nachweisbar gemacht. Manipulationen sind sofort erkennbar, da bei einer gebrochenen oder manipulierten Signatur die Zertifikatsprüfung fehlschlägt und z.B. im Acrobat Reader kein grüner Haken mehr angezeigt wird.'
                    ]
                }
            ]
        },
        {
            title: '{{domain}} in der Praxis',
            items: [
                {
                    question: 'Welche Dokumente können mit {{domain}} signiert werden?',
                    answer: [
                        'Alle gängigen Dokumenttypen wie Word, Excel, Verträge, Angebote, Rechnungen und viele mehr, die vorher in ein PDF umgewandelt werden. Besonders geeignet für rechtlich relevante Dokumente. In der on premise oder durch uns gehosteten Version kann direkt aus Anwendungen oder Fachverfahren, die angebunden wurden, signiert werden'
                    ]
                },
                {
                    question: 'Ist {{domain}} für internationale Unternehmen geeignet?',
                    answer: [
                        'Ja. {{domain}} unterstützt mehrere Rechtsräume (EU, Schweiz, Türkei) und ermöglicht die Abbildung von internationalen Workflows und länderübergreifenden Signaturen.'
                    ]
                },
                {
                    question: 'Können Workflows über Ländergrenzen abgebildet werden?',
                    answer: [
                        'Ja. Signaturen aus Deutschland, der Schweiz und der Türkei sind mit {{domain}} kombinierbar. Damit lassen sich globale Prozesse rechtssicher digitalisieren.'
                    ]
                },
                {
                    question: 'Wie funktioniert die Integration in bestehende Systeme?',
                    answer: [
                        'Über offene API-Schnittstellen kann {{domain}} in ERP-, CRM-, DMS- und HR-Systeme eingebunden werden. Standard-Integrationen sind verfügbar für SAP, Microsoft und DATEV.'
                    ]
                }
            ]
        },
        {
            title: 'Lizenz & Kosten',
            items: [
                {
                    question: 'Wer benötigt eine {{domain}}-Lizenz?',
                    answer: [
                        'Alle Nutzer, die Dokumente erstellen, verwalten oder signieren. Externe Empfänger (nur on premise) benötigen keine Lizenz, um Dokumente zu signieren.'
                    ]
                },
                {
                    question: 'Welche Lizenzmodelle bietet {{domain}}?',
                    answer: [
                        'Flexible Modelle: monatliche Subscriptions pro Nutzer oder volumenbasierte Abrechnung nach Signaturen. Enterprise-Lizenzen auf Anfrage.'
                    ]
                },
                {
                    question: 'Können QES (Qualifizierte Signaturen) einzeln erworben werden?',
                    answer: [
                        'Ja. QES können zusätzlich zu den Basis-Lizenzen erworben werden – entweder als Paket oder einzeln nach Bedarf.'
                    ]
                },
                {
                    question: 'Kann {{domain}} kostenfrei getestet werden?',
                    answer: [
                        'Ja. Es gibt eine kostenlose Testversion, mit der alle Funktionen ausprobiert werden können.'
                    ]
                }
            ]
        },
        {
            title: 'Technische Anforderungen',
            items: [
                {
                    question: 'Systemvoraussetzungen',
                    answer: [
                        'Es wird lediglich ein aktueller Browser benötigt (Chrome, Firefox, Edge, Safari, etc.). Es sind keine zusätzlichen Installationen erforderlich.'
                    ]
                },
                {
                    question: 'Datensicherheit & -übertragung',
                    answer: [
                        'Alle Daten werden verschlüsselt übertragen (TLS 1.3) und in zertifizierten europäischen Rechenzentren gespeichert. Zugriff erfolgt ausschließlich nach dem Need-to-know-Prinzip.'
                    ]
                },
                {
                    question: 'API-Schnittstellen',
                    answer: [
                        'Eine REST-API ermöglicht die nahtlose Integration in bestehende IT-Landschaften. Dokumentation und Beispielcode stehen für Entwickler zur Verfügung.'
                    ]
                }
            ]
        },
        {
            title: '🇩🇪 Internationaler Support',
            items: [
                {
                    question: 'Support-Informationen',
                    answer: [
                        'Der Support ist mehrsprachig verfügbar (Deutsch, Englisch, Türkisch) und unterstützt Kunden in Europa und der Türkei. Kontaktmöglichkeiten: E-Mail, Telefon, Support-Portal.'
                    ]
                }
            ]
        }
    ];
}
